<template>
  <SettingsTable :class="$style.table">
    <SettingsTableRow name="名前">
      <DolphinTextInput v-model="model.name" :class="$style.nameField" />
    </SettingsTableRow>
    <SettingsTableRow name="許可/禁止">
      <SettingsPageAuthzPolicyFormEffect v-model="model.effect" />
    </SettingsTableRow>
    <SettingsTableRow name="操作者">
      <SettingsPageAuthzPolicyFormPrincipal v-model="model.principal" />
    </SettingsTableRow>
    <SettingsTableRow name="操作名">
      <SettingsPageAuthzPolicyFormAction v-model="model.action" />
    </SettingsTableRow>
    <SettingsTableRow name="操作対象">
      <SettingsPageAuthzPolicyFormResource
        v-model="model.resource"
        :actionType="model.action.type"
      />
    </SettingsTableRow>
  </SettingsTable>
</template>

<script lang="ts">
export const formatToGQLInput = (form: AuthzPolicyForm) => {
  return {
    name: form.name,
    effect: form.effect,
    principal: {
      anyPrincipal:
        form.principal.type === 'AnyAuthzPolicyPrincipal' ? {} : undefined,
      staffPrincipal:
        form.principal.type === 'StaffAuthzPolicyPrincipal'
          ? {
              staffGUID: form.principal.id,
            }
          : undefined,
      teamPrincipal:
        form.principal.type === 'TeamAuthzPolicyPrincipal'
          ? {
              teamGUID: form.principal.id,
            }
          : undefined,
    },
    action: {
      anyAction: form.action.type === 'AnyAuthzPolicyAction' ? {} : undefined,
      readRoomAction:
        form.action.type === 'ReadRoomAuthzPolicyAction'
          ? {
              isAssigned: form.action.isAssigned,
            }
          : undefined,
    },
    resource: {
      anyResource:
        form.resource.type === 'AnyAuthzPolicyResource' ? {} : undefined,
      roomResource:
        form.resource.type === 'RoomAuthzPolicyResource'
          ? {
              roomID: form.resource.id,
            }
          : undefined,
    },
  }
}
</script>

<script lang="ts" setup>
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import SettingsPageAuthzPolicyFormEffect, {
  type AuthzPolicyEffectForm,
} from './SettingsPageAuthzPolicyFormEffect.vue'
import SettingsPageAuthzPolicyFormPrincipal, {
  type AuthzPolicyPrincipalForm,
} from './SettingsPageAuthzPolicyFormPrincipal.vue'
import SettingsPageAuthzPolicyFormAction, {
  type AuthzPolicyActionForm,
} from './SettingsPageAuthzPolicyFormAction.vue'
import SettingsPageAuthzPolicyFormResource, {
  type AuthzPolicyResourceForm,
} from './SettingsPageAuthzPolicyFormResource.vue'
import SettingsTable from '@/pages/SettingsPage/SettingsTable/SettingsTable.vue'
import SettingsTableRow from '../../SettingsTable/SettingsTableRow.vue'

// TODO: valibotとか使って型を生成するようにする
export type AuthzPolicyForm = {
  name: string
  effect: AuthzPolicyEffectForm
  principal: AuthzPolicyPrincipalForm
  action: AuthzPolicyActionForm
  resource: AuthzPolicyResourceForm
}

const model = defineModel<AuthzPolicyForm>({ required: true })
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.nameField {
  display: flex;
  width: 100%;
}
</style>
